import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { LAYOUT } from '@/theme';
import { isFullBleed } from '../router/navigation';
import { AppFooter } from './AppFooter';
import { NavRail } from './NavRail';
import { Sidebar } from './Sidebar';
import { useSidebar } from './sidebarStore';
import { TopBar } from './TopBar';

export function AppShell() {
  const [isNavOpen, setNavOpen] = useState(false);
  const { collapsed } = useSidebar();
  const fullBleed = isFullBleed(useLocation().pathname);
  const mainSx = fullBleed ? { flexGrow: 1, minHeight: 0 } : pageSx;
  const desktopNavWidth = collapsed ? LAYOUT.railWidth : LAYOUT.navWidth;

  return (
    <Box sx={{ display: 'flex', minHeight: '100dvh', bgcolor: 'background.default' }}>
      <Box component="nav" aria-label="Main" sx={{ width: { md: desktopNavWidth }, flexShrink: { md: 0 }, transition: widthTransition }}>
        <Drawer
          variant="temporary"
          open={isNavOpen}
          onClose={() => { setNavOpen(false); }}
          sx={{ display: { xs: 'block', md: 'none' }, '& .MuiDrawer-paper': { width: LAYOUT.navWidth } }}
        >
          <Sidebar onNavigate={() => { setNavOpen(false); }} />
        </Drawer>
        <Drawer
          variant="permanent"
          open
          sx={{
            display: { xs: 'none', md: 'block' },
            '& .MuiDrawer-paper': { width: desktopNavWidth, boxSizing: 'border-box', overflowX: 'hidden', transition: widthTransition },
          }}
        >
          {collapsed ? <NavRail /> : <Sidebar />}
        </Drawer>
      </Box>
      <Box sx={{ flexGrow: 1, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
        <TopBar onMenuClick={() => { setNavOpen(true); }} />
        <Box component="main" id="main-content" sx={mainSx}>
          <Outlet />
        </Box>
        {fullBleed ? null : <AppFooter />}
      </Box>
    </Box>
  );
}

const widthTransition = 'width 200ms cubic-bezier(0.2, 0, 0, 1)';

const pageSx = { flexGrow: 1, px: { xs: 2, md: 4 }, py: { xs: 3, md: 4 }, width: '100%', maxWidth: LAYOUT.contentMaxWidth, mx: 'auto' } as const;
